export default function ColHeaderDefault({ children }) {
  return (
    <div className='col-span-1 bg-theme-intel-2020-e-gray-s1 py-2.5 px-1 md:px-2.5 font-medium text-center grid grid-cols-1 content-center text-theme-intel-2020-e-gray-t2 text-srt-table-sm md:text-srt-table-base'>
      {children}
    </div>
  );
}
